import React, { useState } from "react";
import AllInvestmentList from "../All-Investments/all-investment-list";
import Alerts from "../Alerts/Alerts";

const InvestmentHub = () => {
  const [activeTab, setActiveTab] = useState("investment-menu");

  const tabs = [
    {
      id: "investment-menu",
      label: "My Investment",
      component: <AllInvestmentList />
    },
    {
      id: "my-investment",
      label: "Investment Menu",
      component: <Alerts />
    }
 
  ];

  return (
    <div className="pt-4 lg:min-w-[79vw] lg:max-w-[80vw]">
      <div className="p-4 bg-white border-radius-10 text-left">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-semibold text-gray-800">Investment Hub</h1>
        </div>

        {/* Tab Navigation */}
        <div className="border-b border-gray-200 mb-6">
          <nav className="-mb-px flex space-x-8">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors duration-200 ${
                  activeTab === tab.id
                    ? "border-blue-500 text-blue-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>

        {/* Tab Content */}
        <div className="tab-content">
          {tabs.find(tab => tab.id === activeTab)?.component}
        </div>
      </div>
    </div>
  );
};

export default InvestmentHub;
